import { createSelector } from "reselect";

const departmentsSelector = (state) => state.departments;

export const getDepartments = createSelector(
  [departmentsSelector],
  (state) => state.list
);
